export enum EPantryMode {
  Manual = 0,
  Auto = 1,
}
